import React, { PureComponent } from 'react';
import { Tabs, TabsProps } from 'antd';
import './FlexTabs.less';

export class FlexTabs extends PureComponent<TabsProps> {
    render() {
        return <Tabs className="flex-tabs" {...this.props} />;
    }
}
